export default "__VITE_ASSET__BzvpfsuW__"